import type { CSSProperties } from 'react';

/// Recorte guardado de uma imagem: ponto visível em porcentagem e zoom em porcentagem (100 cobre a
/// moldura sem ampliar). O arquivo original não muda; o mesmo recorte vale em qualquer largura.
export type ImageFrame = { x: number; y: number; zoom: number };

export const centeredFrame: ImageFrame = { x: 50, y: 50, zoom: 100 };
export const MAX_ZOOM = 400;

export const clamp = (value: number, min = 0, max = 100) =>
  Math.round(Math.min(max, Math.max(min, value)));

/// `object-position` escolhe o ponto da imagem que encosta no mesmo ponto da moldura; ampliar a
/// partir desse ponto o mantém parado, então 0 e 100 continuam sendo as bordas em qualquer zoom.
export function framedStyle(frame: ImageFrame): CSSProperties {
  return {
    objectPosition: `${frame.x}% ${frame.y}%`,
    ...(frame.zoom > 100
      ? { transform: `scale(${frame.zoom / 100})`, transformOrigin: `${frame.x}% ${frame.y}%` }
      : {}),
  };
}
